import { apiFetch } from '../lib/api';

export interface MapViolation {
  sku: string;
  source_guide: string;
  brand: string | null;
  model: string | null;
  map_price_cents: number;
  effective_price_cents: number;
  retail_cents: number | null;
  msrp_cents: number | null;
  price_source: string | null;
  gap_cents: number;
  pct_below: number;
}

export interface MapCoverageRow {
  source_guide: string;
  total: number;
  has_map: number;
  no_map: number;
  has_effective: number;
  violations: number;
  map_coverage_pct: number;
}

export interface MapChangeRow {
  sku: string;
  source_guide: string;
  brand: string | null;
  prior_map_cents: number | null;
  current_map_cents: number | null;
  change_type: 'added' | 'removed' | 'changed';
  delta_cents: number | null;
  detected_at: string;
}

export function getMapViolations(): Promise<{ violations: MapViolation[]; count: number }> {
  return apiFetch('/admin/map-violations');
}

export function getMapCoverage(): Promise<{ coverage: MapCoverageRow[] }> {
  return apiFetch('/admin/map-coverage');
}

export function getMapChanges(days = 7): Promise<{
  days: number;
  changes: MapChangeRow[];
  count?: number;
  note?: string;
}> {
  return apiFetch(`/admin/map-changes?days=${days}`);
}

export interface ShopifyMapViolation {
  sku: string;
  source_guide: string;
  brand: string | null;
  shopify_variant_id: string;
  shopify_product_id: string | null;
  map_price_cents: number;
  shopify_price_cents: number;
  shopify_compare_at_cents: number | null;
  gap_cents: number;
  pct_below: number;
}

export interface ShopifyMapScanResult {
  scanned: number;
  queried: number;
  violations: ShopifyMapViolation[];
  not_found_in_shopify: string[];
  duration_ms: number;
  note?: string;
}

export function scanStorefrontMap(): Promise<ShopifyMapScanResult> {
  return apiFetch('/admin/map-violations/storefront');
}

export interface MapSyncChange {
  sku: string;
  source_guide: string;
  brand: string | null;
  variant_gid: string;
  product_gid: string;
  shopify_price_cents_before: number;
  shopify_price_cents_after: number;
  map_price_cents: number | null;
  effective_price_cents: number;
  floored_to_map: boolean;
  applied: boolean;
  error: string | null;
}

export interface MapSyncSummary {
  dry_run: boolean;
  scanned: number;
  queried: number;
  unchanged: number;
  drift_detected: number;
  applied: number;
  failed: number;
  not_found_in_shopify: number;
  floored_to_map_count: number;
  by_vendor: Record<string, { drift: number; applied: number; failed: number }>;
  changes: MapSyncChange[];
  truncated?: boolean;
  importJobId?: number;
  duration_ms: number;
}

export function runMapShopifySync(apply: boolean): Promise<MapSyncSummary> {
  return apiFetch('/admin/map-shopify-sync', {
    method: 'POST',
    body: JSON.stringify({ apply }),
    headers: { 'Content-Type': 'application/json' },
  });
}
